import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BHMSCoursePage: React.FC = () => {
  const courseData = {
    title: "BHMS - Bachelor of Homeopathic Medicine & Surgery",
    shortName: "BHMS",
    duration: "5.5 years (4.5 years + 1 year internship)",
    description: "Holistic healing system using natural remedies and patient-centered treatment",
    overview: "Bachelor of Homeopathic Medicine and Surgery (BHMS) is an undergraduate medical degree that focuses on homeopathic medicine - a system of alternative medicine based on the principle of 'like cures like'. This course trains students to diagnose and treat diseases using highly diluted natural substances that stimulate the body's healing mechanisms.",
    eligibility: [
      "10+2 with Physics, Chemistry, Biology",
      "Minimum 50% marks (40% for SC/ST)",
      "NEET qualification mandatory",
      "Age: 17-25 years"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Anatomy",
          "Physiology",
          "Homeopathic Pharmacy",
          "Biochemistry",
          "History of Medicine",
          "Organon of Medicine & Philosophy"
        ]
      },
      {
        year: 2,
        subjects: [
          "Pathology",
          "Microbiology",
          "Forensic Medicine",
          "Materia Medica",
          "Organon of Medicine",
          "Community Medicine"
        ]
      },
      {
        year: 3,
        subjects: [
          "Surgery",
          "Obstetrics & Gynecology",
          "Practice of Medicine",
          "Repertory",
          "Case Taking & Repertorisation",
          "Homeopathic Materia Medica"
        ]
      },
      {
        year: 4,
        subjects: [
          "Pediatrics",
          "Psychiatry",
          "Medicine (Clinical)",
          "Surgery (Clinical)",
          "Obstetrics & Gynecology (Clinical)",
          "Research Methodology"
        ]
      },
      {
        year: 5,
        subjects: [
          "Clinical Training",
          "Internship in Homeopathic Hospitals",
          "Patient Case Studies",
          "Research Project",
          "Community Health Programs",
          "Clinical Practice Management"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Homeopathic Doctor",
        "Medical Officer (Homeopathy)",
        "Clinical Research Associate",
        "Homeopathic Consultant",
        "Professor/Lecturer",
        "Drug Controller",
        "Medical Representative",
        "Health Writer",
        "Hospital Administrator",
        "Private Practice Owner"
      ],
      industries: [
        "Government Hospitals",
        "Private Clinics",
        "Homeopathic Colleges",
        "Pharmaceutical Companies",
        "Research Organizations",
        "NGOs",
        "Wellness Centers",
        "Health Tourism",
        "Publishing Houses",
        "Drug Regulatory Bodies"
      ],
      averageSalary: "₹2.5-7 LPA",
      topRecruiters: [
        "Government Health Departments",
        "Dr. Reckeweg & Co",
        "SBL Pvt Ltd",
        "Hahnemann Publishing",
        "Wellness Centers",
        "Private Hospitals"
      ]
    },

    topColleges: [
      {
        name: "National Institute of Homeopathy",
        location: "Kolkata, West Bengal",
        fees: "₹15,000/year",
        ranking: "9.3/10"
      },
      {
        name: "Dr. M.L. Dhawale Memorial Trust",
        location: "Mumbai, Maharashtra",
        fees: "₹35,000/year",
        ranking: "9.0/10"
      },
      {
        name: "Nehru Homeopathic Medical College",
        location: "Delhi",
        fees: "₹40,000/year",
        ranking: "8.8/10"
      },
      {
        name: "Father Muller Homeopathic Medical College",
        location: "Mangalore, Karnataka",
        fees: "₹50,000/year",
        ranking: "8.6/10"
      },
      {
        name: "Bakson Homeopathic Medical College",
        location: "Greater Noida, UP",
        fees: "₹45,000/year",
        ranking: "8.4/10"
      }
    ],

    skills: [
      "Case Taking & Analysis",
      "Repertorisation Techniques",
      "Homeopathic Philosophy",
      "Patient Counseling",
      "Clinical Observation",
      "Natural Healing Methods",
      "Research & Documentation",
      "Holistic Health Assessment",
      "Medicine Preparation",
      "Therapeutic Communication"
    ],

    futureScope: "Growing acceptance of alternative medicine globally, integration with conventional healthcare, government support for AYUSH systems, increasing patient preference for natural healing, research opportunities in homeopathic medicine, international practice opportunities, wellness industry growth, telemedicine applications, and academic research positions.",

    faqs: [
      {
        question: "Is BHMS a recognized medical degree?",
        answer: "Yes, BHMS is a recognized medical degree under the Central Council of Homeopathy (CCH) and Ministry of AYUSH, Government of India."
      },
      {
        question: "Can BHMS doctors prescribe allopathic medicines?",
        answer: "BHMS doctors are primarily trained in homeopathic medicine. They cannot prescribe allopathic medicines unless they have additional qualifications."
      },
      {
        question: "What is the difference between BHMS and MBBS?",
        answer: "BHMS focuses on homeopathic medicine using natural remedies, while MBBS focuses on conventional allopathic medicine. Both are recognized medical degrees."
      },
      {
        question: "Can I pursue specialization after BHMS?",
        answer: "Yes, you can pursue MD (Homeopathy) in various specializations like Materia Medica, Organon, Repertory, etc."
      },
      {
        question: "Is NEET required for BHMS admission?",
        answer: "Yes, NEET is mandatory for admission to BHMS courses in all recognized homeopathic medical colleges."
      },
      {
        question: "What is the scope of BHMS in government jobs?",
        answer: "BHMS graduates can work as Medical Officers in government hospitals, health centers, and AYUSH departments."
      }
    ],

    admissionProcess: [
      "NEET Qualification",
      "State/National Counseling Registration",
      "Choice Filling & Document Verification",
      "Seat Allotment",
      "College Reporting & Fee Payment"
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BHMSCoursePage;
